// extracted by mini-css-extract-plugin
module.exports = {"InformationText":"InformationText_InformationText__xsj9R","InformationText_text":"InformationText_InformationText_text___t_Pf"};